module.exports = __webpack_public_path__ + "img/toyota-New.4fdd9d1b.png";